import React from "react";
import { FormComponent } from "./FormComponent";
import { Control, FieldValues, useController } from "react-hook-form";

/* eslint @typescript-eslint/no-explicit-any: "off" */

type TextFieldProps<T extends FieldValues> = {
	autoComplete?: string;
	classes?: string;
	control: Control<T>;
	disabled?: boolean;
	id: string;
	inputClasses?: string;
	label: string;
	name: string;
	onFocus?: () => void;
	onInputChange?: (name: string, value: string) => void;
	placeholder?: string;
	required?: boolean;
	validate?: (value: unknown) => true | string;
};

export function TextField({
	autoComplete,
	classes,
	control,
	disabled = false,
	id,
	inputClasses,
	label,
	name,
	onFocus,
	onInputChange,
	placeholder,
	required = false,
	validate,
}: TextFieldProps<any>) {
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
			validate,
		},
	});

	const component = { id, name, label, required, errors, classes };

	const handleChange = (value: string) => {
		onInputChange && onInputChange(name, value);
		onChange(value);
	};

	return (
		<FormComponent {...component}>
			<input
				type="text"
				className={inputClasses}
				disabled={disabled}
				id={id}
				onFocus={onFocus}
				onChange={(e) => handleChange(e.target.value)}
				placeholder={placeholder}
				autoComplete={autoComplete}
				value={value || ""}
			/>
		</FormComponent>
	);
}
